module.exports = __webpack_public_path__ + "img/9791156330493.6966fa7f.jpg";